import React from 'react';
import { Upload, ArrowRight, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Button from 'shared/components/ui/Button';
import { URLS } from 'configs';
import HeroImage from 'assets/landing/hero-fashion-new.jpg';
import './HeroSection.scss';

const HeroSection = () => {
  const { t } = useTranslation();

  const features = [
    t('hero_feature_tryon', 'Virtual Try-On'),
    t('hero_feature_comparison', 'AI Product Comparison'),
    t('hero_feature_wishlists', 'Smart Wishlists'),
    t('hero_feature_extension', 'Browser Extension'),
    t('hero_feature_visual_search', 'Visual Search'),
    t('hero_feature_price_tracking', 'Price Tracking'),
  ];

  return (
    <section className='hero-section'>
      {/* Animated Background Elements */}
      <div className='hero-section__bg-gradient' />
      <div className='hero-section__bg-blob hero-section__bg-blob--primary' aria-hidden='true' />
      <div className='hero-section__bg-blob hero-section__bg-blob--secondary' aria-hidden='true' />

      <div className='hero-section__container'>
        <div className='hero-section__grid'>
          {/* Left Content */}
          <div className='hero-section__content animate-fade-in'>
            {/* Trust Badge */}
            <div className='hero-section__trust-badge'>
              <div className='hero-section__trust-avatars'>
                <div className='hero-section__trust-avatar' />
                <div className='hero-section__trust-avatar' />
                <div className='hero-section__trust-avatar' />
              </div>
              <span className='hero-section__trust-text'>
                {t('hero_trust_badge', 'Trusted by 10,000+ Smart Shoppers')}
              </span>
            </div>

            <h1 className='hero-section__title'>
              {t('hero_title_line1', 'Your Smart')}
              <br />
              <span className='hero-section__title--gradient'>{t('hero_title_line2', 'AI Shopping')}</span>
              <br />
              {t('hero_title_line3', 'Assistant')}
            </h1>

            <p className='hero-section__description'>
              {t(
                'hero_description',
                'Try on fashion virtually, compare products with AI, create shared wishlists, and discover better deals—all in one place.',
              )}
            </p>

            {/* Key Features List */}
            <div className='hero-section__features'>
              {features.map((feature, i) => (
                <div key={i} className='hero-section__feature-item'>
                  <Check className='hero-section__feature-icon' />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className='hero-section__cta-group'>
              <a href={URLS.CONTACT} className='hero-section__cta-link'>
                <Button variant='hero' size='xl' className='hero-section__cta-btn'>
                  <Upload size={20} />
                  {t('contact_us', 'Contact us')}
                  <ArrowRight size={20} />
                </Button>
              </a>
              {/* <Link to='#demo'>
                <Button variant='outline' size='xl' className='hero-section__cta-btn'>
                  <Play size={20} />
                  {t('hero_cta_watch_demo', 'Watch Demo')}
                </Button>
              </Link> */}
            </div>

            {/* Stats */}
            <div className='hero-section__stats'>
              <div className='hero-section__stat'>
                <div className='hero-section__stat-value'>500K+</div>
                <div className='hero-section__stat-label'>{t('hero_stat_items', 'Items Saved')}</div>
              </div>
              <div className='hero-section__stat'>
                <div className='hero-section__stat-value'>10K+</div>
                <div className='hero-section__stat-label'>{t('hero_stat_users', 'Active Users')}</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className='hero-section__image-wrapper animate-scale-in'>
            <div className='hero-section__image-container'>
              <img
                src={HeroImage}
                alt={t(
                  'hero_image_alt',
                  'AI-powered shopping assistant with virtual try-on, product comparison, and smart wishlist features',
                )}
                className='hero-section__image'
                loading='eager'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
